(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var dot = e.target.closest('button.hp-cs__dot');
    if (!dot) return;
    e.preventDefault();
    var card = dot.closest('.card-wrapper, .hp-pcard');
    if (!card) return;
    dot.parentElement.querySelectorAll('.hp-cs__dot').forEach(function (d) {
      d.classList.toggle('is-on', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    var img = card.querySelector('.card__media .media img, .hp-pcard__media img');
    if (img && dot.dataset.img) {
      img.src = dot.dataset.img;
      if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
    }
    if (dot.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link, a.hp-pcard__link').forEach(function (a) { a.href = dot.dataset.url; });
    }
    var now = card.querySelector('.hp-price__now, .hp-pcard__price .now');
    if (now && dot.dataset.price) now.textContent = dot.dataset.price;
    var was = card.querySelector('.hp-price__was, .hp-pcard__price .was');
    var save = card.querySelector('.hp-price__save');
    if (was) { was.textContent = dot.dataset.was || ''; was.hidden = !dot.dataset.was; }
    if (save) { save.textContent = dot.dataset.save || ''; save.hidden = !dot.dataset.save; }
    var qa = card.querySelector('input[name="id"]');
    if (qa && dot.dataset.variant) qa.value = dot.dataset.variant;
    card.querySelectorAll('[data-hp-stock]').forEach(function (st) { st.hidden = dot.dataset.instock !== '1'; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-inline-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('details.hp-scope[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.hp-scope[open]').forEach(function (details) {
      details.removeAttribute('open');
    });
  });

  // Show a "Popular" panel while the search field is focused and empty.
  (function () {
    function init() {
      var wrap = document.querySelector('.hp-search');
      if (!wrap) return;
      var input = wrap.querySelector('#HpSearchInput');
      var popular = wrap.querySelector('[data-hp-popular]');
      if (!input || !popular) return;
      function update() {
        var empty = input.value.trim().length === 0;
        var focused = document.activeElement === input;
        popular.hidden = !(empty && focused);
      }
      input.addEventListener('focus', update);
      input.addEventListener('input', update);
      input.addEventListener('blur', function () { setTimeout(update, 150); });
      wrap.addEventListener('click', function (event) {
        if (event.target.closest('.hp-search__reset')) {
          setTimeout(function () { input.focus(); update(); }, 0);
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  // Rotating placeholder: cycle example searches with a typewriter effect.
  (function () {
    function initRotor() {
      document.querySelectorAll('.hp-search[data-suggestions]').forEach(function (wrap) {
        var input = wrap.querySelector('.hp-search__input');
        if (!input) return;
        var list = (wrap.getAttribute('data-suggestions') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
        if (!list.length) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { input.placeholder = 'Search "' + list[0] + '"'; return; }
        var i = 0, ch = 0, deleting = false, timer = null, paused = false;
        var PRE = 'Search ';
        function frame() {
          if (paused) return;
          var full = '"' + list[i] + '"';
          if (!deleting) {
            ch++;
            input.placeholder = PRE + full.slice(0, ch);
            if (ch >= full.length) { deleting = true; timer = setTimeout(frame, 1700); return; }
            timer = setTimeout(frame, 65);
          } else {
            ch--;
            input.placeholder = PRE + full.slice(0, ch);
            if (ch <= 0) { deleting = false; i = (i + 1) % list.length; timer = setTimeout(frame, 320); return; }
            timer = setTimeout(frame, 30);
          }
        }
        input.addEventListener('input', function () { if (input.value.trim().length) { paused = true; clearTimeout(timer); } });
        frame();
      });
    }
    if (document.readyState !== 'loading') initRotor();
    else document.addEventListener('DOMContentLoaded', initRotor);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-pet-chip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('details.hp-petchip[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-size-finder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hp-sizefinder__btn');
    if (!btn) return;
    var wrap = btn.closest('.hp-sizefinder');
    var input = wrap.querySelector('.hp-sizefinder__input');
    var out = wrap.querySelector('.hp-sizefinder__result');
    var w = parseFloat(input.value);
    if (isNaN(w) || w <= 0) {
      out.textContent = "Please enter your pet's weight in pounds.";
      return;
    }
    var size = w <= 10 ? 'XS' : w <= 25 ? 'S' : w <= 50 ? 'M' : w <= 80 ? 'L' : 'XL';
    out.textContent = 'We recommend size ' + size + ' for a ' + w + ' lb pet.';
  });
  } catch(e) { console.error(e); }
})();

})();
